import React from "react";
import setupOne from "../images/setup-1.png";
import create from "../images/create.png";
import setup from "../images/setup.png";
import add from "../images/add.png";
import artimg from "../images/art.png";
import collectiblesimg from "../images/collectibles.png";
import entertainmentimg from "../images/entertainment.png";
import esportsimg from "../images/espo.png";
import gamingimg from "../images/gaming.png";
import nftforgoodimg from "../images/nftforgood.png";
import sportsimg from "../images/sports.png";
import slide1 from "../images/slider/1.png";
import slide2 from "../images/slider/2.png";
import slide3 from "../images/slider/3.png";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, {
  EffectFade,
  Navigation,
  Pagination,
  Autoplay,
} from "swiper";
import "swiper/swiper-bundle.css";
import { Link } from "react-router-dom";

SwiperCore.use([EffectFade, Navigation]);
SwiperCore.use([Autoplay]);
const Home = () => {
  const cat = "art";
  const collectables = "collectables";
  const entertainment = "entertainment";
  const esports = "esports";
  const gaming = "gaming";
  const nftforgood = "nftforgood";
  const sports = "sports";

  return (
    <div className="parent-div">
      <Swiper
        autoplay={{
          delay: 10000,
          disableOnInteraction: false,
        }}
        speed={200}
        effect="fade"
        slidesPerView={1}
      >
        <SwiperSlide>
          <img src={slide1} width="1280" height="500" />{" "}
        </SwiperSlide>
        <SwiperSlide>
          <img src={slide2} width="1280" height="500" />
        </SwiperSlide>
        <SwiperSlide>
          <img src={slide3} width="1280" height="500" />
        </SwiperSlide>
      </Swiper>

      <div className="row cards-div text-center">
        <div className="col-md-3 mascot_col">
          <div class="card">
            <img className="card-img-top" src={setupOne} alt="Setup" />
            <div className="card-body">
              <h3 className="card-title">Setup your Wallet</h3>
              <p className="card-text">
                Click on Connect Button, Choose metamask & Sign in with your
                metamask.
              </p>
            </div>
          </div>
        </div>
        <div className="col-md-3 mascot_col">
          <div className="card">
            <img className="card-img-top" src={create} alt="Card image cap" />
            <div className="card-body">
              <h3 className="card-title">Create your collection​</h3>
              <p className="card-text">
                Do you see a "create" button? Click it and Start your
                collections creation journey.
              </p>
            </div>
          </div>
        </div>
        <div className="col-md-3 mascot_col">
          <div className="card" style={{ width: "18rem" }}>
            <img className="card-img-top" src={add} alt="Card image cap" />
            <div className="card-body">
              <h3 className="card-title">Add your Nfts</h3>
              <p className="card-text">
                Give your NFT a name, add description & category, put on sales
                by selecting given options & the price.
              </p>
            </div>
          </div>
        </div>

        <div className="col-md-3 mascot_col">
          <div className="card" style={{ width: "18rem" }}>
            <img className="card-img-top" src={setup} alt="Card image cap" />
            <div className="card-body">
              <h3 class="card-title">List Them for Sale</h3>
              <p class="card-text">
                Filled all details in creation? Click on "List NFT", pay the
                minimum fee in "BNB". Congrats you have minted & listed your
                NFT!
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="cat-section-title container">
        <h2>Browse By Category</h2>
        <h6>
          Click on the category you are interested in to browse that category!
        </h6>
      </div>

      <div className="cat-slider-div container">
        <Swiper
          loop={true}
          loopFillGroupWithBlank={false}
          slidesPerGroup={1}
          navigation={true}
          slidesPerView={4}
          spaceBetween={40}
          modules={[Navigation, Pagination]}
          //onSlideChange={() => console.log('slide change')}
          //onSwiper={(swiper) => console.log(swiper)}
        >
          <SwiperSlide>
            {" "}
            <Link to={`/category/${cat}`}>
              {" "}
              <img src={artimg} alt="Setup" />{" "}
            </Link>{" "}
          </SwiperSlide>
          <SwiperSlide>
            {" "}
            <Link to={`/category/${collectables}`}>
              {" "}
              <img src={collectiblesimg} alt="Setup" />
            </Link>
          </SwiperSlide>
          <SwiperSlide>
            {" "}
            <Link to={`/category/${entertainment}`}>
              {" "}
              <img src={entertainmentimg} alt="Setup" />{" "}
            </Link>{" "}
          </SwiperSlide>
          <SwiperSlide>
            {" "}
            <Link to={`/category/${esports}`}>
              {" "}
              <img src={esportsimg} alt="Setup" />
            </Link>{" "}
          </SwiperSlide>
          <SwiperSlide>
            {" "}
            <Link to={`/category/${gaming}`}>
              {" "}
              <img src={gamingimg} alt="Setup" />{" "}
            </Link>{" "}
          </SwiperSlide>
          <SwiperSlide>
            {" "}
            <Link to={`/category/${nftforgood}`}>
              {" "}
              <img src={nftforgoodimg} alt="Setup" />{" "}
            </Link>{" "}
          </SwiperSlide>
          <SwiperSlide>
            {" "}
            <Link to={`/category/${sports}`}>
              {" "}
              <img src={sportsimg} alt="Setup" />{" "}
            </Link>{" "}
          </SwiperSlide>
        </Swiper>
      </div>
    </div> /*Outer div*/
  );
};

export default Home;
